import { createStore } from 'vuex'

// P1頁參數
const queryParams = {
  namespaced: true,
  state: {
    promoCode: '',
    promoEmpNo: '',
    seedNo: '',
    payType: ''
  },
  mutations: {
    update (state, params) {
      Object.assign(state, params)
    },
    reset (state) {
      state.promoCode = ''
      state.promoEmpNo = ''
      state.seedNo = ''
      state.payType = ''
    }
  },
  actions: {
    cache (context, params) {
      context.commit('update', params)
    }
  }
}

// P3 POST參數
const GetNextFromOtpRsVM = {
  namespaced: true,
  state: {

  },
  mutations: {
    update (state, params) {
      Object.assign(state, params)
    },
    reset (state) {
      Object.keys(state).forEach(key => {
        delete state[key]
      })
    }
  },
  actions: {}
}

// 跨頁導頁暫存，接收頁讀取後立即清除
const routeTransfer = {
  namespaced: true,
  state: {
    data: null
  },
  mutations: {
    update (state, params) {
      state.data = params
    },
    reset (state) {
      state.data = null
    }
  },
  actions: {}
}

export default createStore({
  state: {
    aes1: '1019E2991V09O17L1019E2991V09O17L',
    aes2: '1019E2991V09O17L',
    isLoading: false,
    // 錯誤導頁計時器
    errorPageCounter: null,
    showGoHome: true,
    // 新增代繳、代繳查詢FLAG
    actionType: '',
    // 存放otp回覆
    jwt: '',
    // 客服小c網址
    botUrl: ''
  },
  mutations: {
    showLoading (state) {
      state.isLoading = true
    },
    hideLoading (state) {
      state.isLoading = false
    },
    setActionType (state, value) {
      state.actionType = value
    },
    resetActionType (state) {
      state.actionType = ''
    },
    setJwt (state, value) {
      state.jwt = value
    },
    setBotUrl (state, value) {
      state.botUrl = value
    }
  },
  actions: {
  },
  modules: {
    queryParams,
    GetNextFromOtpRsVM,
    routeTransfer
  },
  getters: {
    getAes1: state => {
      return state.aes1
    },
    getAes2: state => {
      return state.aes2
    },
    getJwt: state => {
      return state.jwt
    },
    // 種子代碼隱碼
    seedCodeMasked () {
      let target = queryParams.state.seedNo
      let length = target.length
      let count = Math.floor(length / 3)
      let less = length % 3
      let element = ''
      for (let index = 0; index < count; index++) {
        element += '*'
      }
      target = target.length === 2 ? `${target.slice(0, 1)}*` : target
      if (less === 0) {
        target = `${target.slice(0, count)}${element}${target.slice(length - count)}`
      }
      if (less === 1) {
        target = `${target.slice(0, count + 1)}${element}${target.slice(length - count)}`
      }
      if (less === 2) {
        target = `${target.slice(0, count + 1)}${element}${target.slice(length - count - 1)}`
      }
      return target
    }
  }
})
